'use client'

import { useEffect } from 'react'
import { useRouter } from '@/i18n/navigation'

/**
 * This component reloads the application when an update from Strapi is reported. This is useful for the sidebar preview
 * in case of Growth or EE plans.
 *
 * I did not have access to either of these at the time of writing, so I am unable to validate if this works correctly.
 *
 * It does not impact the static preview in Community version of Strapi, as user has to leave the preview in order to change content.
 */
function StrapiPreviewListener() {
	const router = useRouter()

	// biome-ignore lint/correctness/useExhaustiveDependencies: router will be mounted
	useEffect(() => {
		const handleMessage = (message: MessageEvent) => {
			if (message?.data?.type === 'strapiUpdate') {
				router.refresh()
			}
		}

		window.addEventListener('message', handleMessage)

		return () => {
			window.removeEventListener('message', handleMessage)
		}
	}, [])

	return null
}

export default StrapiPreviewListener
